














































import AppForm from '@core/components/AppForm.vue'
import AppCard from '@core/components/AppCard.vue'
import { Component, Prop, Vue } from 'vue-property-decorator'
import { ClientPolicyDto } from '../../api'
import { options } from '@master/model/options/Options'

@Component({
  components: {
    AppForm,
    AppCard
  }
})
export default class PolicyIndividualSection extends Vue {
  @Prop({ default: [] }) private readonly policyIndividuals
  @Prop({ default: [] }) private clientList
  @Prop({ default: [] }) private rolesOption: options[]
  @Prop({ default: {} }) private policy: ClientPolicyDto
  @Prop({ default: false }) private isAllActionDisabled

  // Component Variables
  private currentSelectedIndividual = null

  emitSelectedIndividual (individual) {
    this.$emit('policy-individual-selected', individual)
    this.currentSelectedIndividual = individual
  }

  // @TODO: We need to make it into an enum! Tidy up next please.
  get isUnableToAddIndividual () {
    return ['employeebenefits', 'group-gi', 'group-eb', 'group-eb-tailored', 'gi-health-group'].includes(this.policy.type)
  }

  roleDisplayName (role) {
    return this.rolesOption.find(option => role === option.value)?.label || role.charAt(0).toUpperCase() + role.slice(1)
  }

  isMainOwner (individual) {
    return individual.isMainOwner
  }

  isJointOwner (individual) {
    return individual.role?.includes('jointOwner')
  }

  userTag (individual) {
    return individual?.clientDataSnapshot?.clientId || ''
  }

  isCurrentCardActive (individual) {
    return this.currentSelectedIndividual?.oid === individual.oid
  }
}
